
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartUnknown as ObiChartUnknownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-unknown.js';
 
 
 

 
 export const ObiChartUnknown = createComponent({
   react: React,
   tagName: 'obi-chart-unknown',
   elementClass: ObiChartUnknownElement,
   events: {
     
   }
  });
 
 